const videoRouter = {
  path: "/video/:id/:type",
  name: "video",
  meta: { auth: true },
  component: () => import("@/views/Video.vue")
};

export default videoRouter;
